export default __webpack_public_path__ + "42fa3348736544be69c5289579915768.svg";